module.exports = __webpack_public_path__ + "media/images/h-coin-gray-4717544db60f4397683b9992cad08905.svg";